module.exports = __webpack_public_path__ + "static/media/Truck_icon.64da2133.svg";